if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');

      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) {
        idInput.disabled = false;
      }

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );

      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (
        this.submitButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector(
        '.loading-overlay__spinner'
      );

      if (spinner) {
        spinner.classList.remove('hidden');
      }

      const config = fetchConfig('javascript');

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          'sections',
          this.cart
            .getSectionsToRender()
            .map((section) => section.id)
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        this.cart.setActiveElement(
          document.activeElement
        );
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          /*
           * LISAMISE VIGA
           */
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });

            this.handleErrorMessage(
              response.description
            );

            const soldOutMessage =
              this.submitButton.querySelector(
                '.sold-out-message'
              );

            if (soldOutMessage) {
              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              const buttonText =
                this.submitButton.querySelector('span');

              if (buttonText) {
                buttonText.classList.add('hidden');
              }

              soldOutMessage.classList.remove('hidden');
            }

            this.error = true;
            return;
          }

          /*
           * TOODE LISATI EDUKALT
           */
          this.error = false;

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
          });

          /*
           * CART TYPE = PAGE
           *
           * Ei suuna klienti automaatselt ostukorvi.
           * Loeme värske korvi ja uuendame päises
           * oleva ostukorvi numbri.
           */
          if (!this.cart) {
            return fetch('/cart.js')
              .then((cartResponse) => {
                if (!cartResponse.ok) {
                  throw new Error(
                    'Korvi andmete laadimine ebaõnnestus'
                  );
                }

                return cartResponse.json();
              })
              .then((cartData) => {

                /*
                 * KORVI NUMBER
                 */
                const cartBubbles = document.querySelectorAll('.cart-count-bubble');

cartBubbles.forEach((cartBubble) => {
  cartBubble.style.display =
    cartData.item_count > 0 ? '' : 'none';

  const count = cartBubble.querySelector(
    'span[aria-hidden="true"]'
  );

  if (count) {
    count.textContent = cartData.item_count;
  }
});

                /*
                 * KORVI IKOON
                 */
                const cartIconBubble =
                  document.querySelector(
                    '.cart-icon-bubble'
                  );

                if (
                  cartIconBubble &&
                  cartData.item_count > 0
                ) {
                  cartIconBubble.classList.add(
                    'cart-icon-bubble_hide-tablet'
                  );
                }
              })
              .catch((error) => {
                console.error(
                  'Cart count update failed:',
                  error
                );
              });
          }

          /*
           * DRAWER / NOTIFICATION
           * Kui kunagi cart type tagasi muudetakse,
           * jääb Minioni originaalkäitumine alles.
           */
          const quickAddModal =
            this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(
                    response
                  );
                });
              },
              { once: true }
            );

            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })

        .catch((error) => {
          console.error(error);
        })

        .finally(() => {
          this.submitButton.classList.remove(
            'loading'
          );

          if (
            this.cart &&
            this.cart.classList.contains('is-empty')
          ) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute(
              'aria-disabled'
            );
          }

          const spinner = this.querySelector(
            '.loading-overlay__spinner'
          );

          if (spinner) {
            spinner.classList.add('hidden');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(
          '.product-form__error-message-wrapper'
        );

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(
          '.product-form__error-message'
        );

      this.errorMessageWrapper.toggleAttribute(
        'hidden',
        !errorMessage
      );

      if (errorMessage) {
        this.errorMessage.textContent =
          errorMessage;
      }
    }
  });
}


/*
 * STICKY CART
 */

class stickyCartModal extends HTMLElement {
  constructor() {
    super();

    window.addEventListener(
      'scroll',
      this.update.bind(this)
    );

    this.update();

    const footer = document.querySelector('footer');

    if (footer) {
      footer.classList.add(
        'sticky-cart-modal_bottom_padding'
      );
    }
  }

  update() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!button) return;

    const addButton =
      button.querySelector('[name="add"]');

    if (!addButton) return;

    const rangeToShowModal =
      this.getTop(addButton) +
      button.clientHeight;

    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains('show-modal')
    ) {
      this.classList.add('show-modal');

      document
        .querySelector('body')
        .classList.add('modal__sticky-cart');
    }

    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains('show-modal')
    ) {
      this.classList.remove('show-modal');

      document
        .querySelector('body')
        .classList.remove('modal__sticky-cart');
    }
  }

  getTop(el) {
    return (
      el.offsetTop +
      (el.offsetParent
        ? this.getTop(el.offsetParent)
        : 0)
    );
  }
}

if (!customElements.get('sticky-cart-modal')) {
  customElements.define(
    'sticky-cart-modal',
    stickyCartModal
  );
}